<template>
  <div class="footerContacts grey lighten-3">
    <div class="container col">
      <div class="row">
        <div class="col s12 m4">
          <div class="footerContacts__block">
            <div class="icon">
              <img
                :alt="$t('phone')"
                src="/img/call_icon.svg"
                height="40"
                width="40"
              />
            </div>
            <div class="title">
              <ul class="communication-list">
                <li>
                  <a
                    :href="`tel:${confMain.phone?.replace(/\D+/g, '')}`"
                    :title="$t('callTollFreeDescr')"
                  >
                    {{ confMain.phone }}
                  </a>
                </li>
                <!-- <li>
                  <a
                    :href="`tel:${confMain.phoneLocal?.replace(/\D+/g, '')}`"
                    :title="$t('localPhoneNumber')"
                  >
                    {{ confMain.phoneLocal }}
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="footerContacts__block">
            <div class="icon">
              <img
                :alt="$t('location')"
                src="/img/location_icon.svg"
                height="40"
                width="40"
              />
            </div>
            <div class="title">
              <address v-html="confMain.location">
              </address>
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="footerContacts__block">
            <div class="icon">
              <img
                :alt="$t('emailSite', { siteName: confMain.siteName })"
                src="/img/email_icon.svg"
                height="40"
                width="40"
              />
            </div>
            <div class="title">
              <ul class="communication-list">
                <li>
                  <a
                    :href="`mailto:${confMain.email}`"
                    :title="$t('emailSite', { siteName: confMain.siteName })"
                  >
                    {{ confMain.email }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { confMain } = useConfig()
</script>

<style lang="scss">
.page-footer {
  .footerContacts {
    padding: 30px 0;
    &__block {
      display: flex;
      align-items: center;
      line-height: 1.47;
      @media only screen and (max-width: 600px) {
        justify-content: flex-start;
        padding: .5rem 0;
      }
      .icon {
        flex: 0 0 auto;
        width: 24px;
        height: 24px;
        margin-right: 15px;
        @media only screen and (max-width: 600px) {
          width: 40px;
          height: 40px;
          margin-right: 20px;
        }
        img {
          width: 40px;
          max-width: 100%;
          height: 40px;
          max-height: 100%;
          @media only screen and (max-width: 600px) {
            width: 24px;
            height: 24px;
          }
        }
      }
      .title {
        @media only screen and (max-width: 600px) {
          justify-content: flex-start;
          margin: 0;
        }
        a,
        address {
          font-style: normal;
          font-weight: 500;
        }
        .communication-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          overflow: hidden;
          margin: 0 -15px;
          li {
            position: relative;
            padding: 0 15px;
            &:after {
              content: "";
              position: absolute;
              top: 50%;
              left: -3px;
              display: block;
              width: 3px;
              height: 3px;
              background: currentColor;
              border-radius: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
}
</style>
